const isDateInPastUtil = (dateStr: string | null | undefined): boolean => {
  if (!dateStr) {
    return false;
  }
  const inputDate = new Date(dateStr);
  const currentDate = new Date();

  if (isNaN(inputDate.getTime())) {
    return false;
  }

  const inputYear = inputDate.getFullYear();
  const inputMonth = inputDate.getMonth();
  const inputDay = inputDate.getDate();

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  if (inputYear < currentYear) {
    return true;
  } else if (inputYear === currentYear && inputMonth < currentMonth) {
    return true;
  } else if (inputYear === currentYear && inputMonth === currentMonth && inputDay < currentDay) {
    return true;
  }

  return false;
};

export default isDateInPastUtil;
